import React from "react";
import { Box } from "@mui/material";

const HorizontalLine = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "4px",
        backgroundColor: "#898989", // Matches the gray color
        borderRadius: "2px",
        opacity: 0.7,
      }}
    />
  );
};

export default HorizontalLine;
